// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Icon, Tooltip, Typography } from '@material-ui/core';
import { GridOverlay, GridToolbar } from '@material-ui/data-grid';
import Popover from 'material-ui-popup-state/HoverPopover';
import { usePopupState, bindPopover } from 'material-ui-popup-state/hooks';
import { DataTable, EmptyState } from '../../../../common/components';
import { DateUtils } from '../../../../common/utils';
import styled from '@material-ui/styles/styled';
import { bindToggle } from 'material-ui-popup-state/core';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '0',
      minWidth: '500px',
      '& .MuiDataGrid-row': {
        '& .MuiIcon-root': {
          maxWidth: '0',
        },
        '&:hover .MuiIcon-root': {
          maxWidth: 'none',
        },
      },
    },
  },
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 'auto',
  },
  popover: {
    pointerEvents: 'none',
  },
  closeicon: {
    cursor: 'pointer',
    position: 'relative',
    margin: '10px',
    float: 'right',
  },
}));

const InfoBox = styled(Popover)`
  & .MuiPaper-root {
    border-radius: 1px;
    background: #138d75;
    color: white;
  }
`;

function CorrespondenceTab(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const { data } = props;

  const [sortModel, setSortModel] = React.useState([
    {
      field: 'timestamp',
      sort: 'desc',
    },
  ]);

  const getColumnDefs = () => [
    {
      field: 'timestamp',
      headerName: t('correspondence.correspondenceTimestamp'),
      width: 200,
      type: 'dateTime',
      valueFormatter: params => DateUtils.getDateTime(params.value),
    },
    {
      field: 'recipient',
      headerName: t('correspondence.correspondenceRecipient'),
      width: 250,
    },
    {
      field: 'subject',
      headerName: t('correspondence.correspondenceSubject'),
      width: 250,
      flex: 0.75,
    },
    {
      field: 'type',
      headerName: t('correspondence.correspondenceType'),
      width: 250,
    },
  ];

  const getRowData = () =>
    data.map((correspondence, index) => ({
      ...correspondence,
      id: index,
    }));

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('correspondence.correspondenceEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="CorrespondenceTab-container" className={classes.container}>
      <DataTable
        id="CorrespondenceTab-table"
        components={{
          Toolbar: GridToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        pageSize={20}
        paginationMode="client"
        pagination
        sortModel={sortModel}
      />
    </Box>
  );
}

CorrespondenceTab.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CorrespondenceTab;
